"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticDateRangePicker = void 0;
const pickers_1 = require("@material-ui/pickers");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const shiftTZLocalToX_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZLocalToX"));
const shiftTZXToLocal_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZXToLocal"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const makePicker_1 = __importDefault(require("../helpers/makePicker"));
const makeMyClasses = () => ({
    root: {
        '& .MuiPickersDesktopDateRangeCalendar-arrowSwitcher': {
            padding: '0 16px 0 16px',
        },
        '& .MuiPickersCalendar-calendarContainer': {
            minHeight: 254,
        },
        '& .MuiPickersDay-dayOutsideMonth': {
            opacity: 0.4,
            '&.MuiPickersDateRangeDay-dayInsideRangeInterval': {
                backgroundColor: lib_palette_1.default.LightBlue.main,
            },
        },
        '& .MuiPickersDateRangeDay-rangeIntervalDayHighlight': {
            backgroundColor: lib_palette_1.default.LightBlue.main,
        },
        '& .MuiPickersDay-daySelected': {
            backgroundColor: lib_palette_1.default.secondary.main,
        },
        '& .MuiPickersDay-day:focus.MuiPickersDay-daySelected': {
            backgroundColor: lib_palette_1.default.secondary.main,
        },
    },
});
exports.StaticDateRangePicker = (0, makePicker_1.default)((props) => {
    const { calendars = 1, disabled, value, timezone, onChange } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const pickerValue = timezone ? value.map(v => (0, shiftTZXToLocal_1.default)(v, timezone)) : value;
    const handleChange = (0, react_1.useCallback)(v => {
        onChange === null || onChange === void 0 ? void 0 : onChange(timezone ? v.map(vv => (0, shiftTZLocalToX_1.default)(vv, timezone)) : v);
    }, [onChange, timezone]);
    const handleRender = (0, react_1.useCallback)(() => react_1.default.createElement("div", null), []);
    return (react_1.default.createElement(pickers_1.StaticDateRangePicker, { disabled: disabled, showDaysOutsideCurrentMonth: true, className: myCss.root, calendars: calendars, displayStaticWrapperAs: "desktop", renderInput: handleRender, value: pickerValue, onChange: handleChange }));
});
exports.default = exports.StaticDateRangePicker;
